import { STORAGE_KEY } from "./constants";

export const defaultState = () => ({
  berries: 0,
  wheelsBuilt: 0,
  perClick: 1,
  upgrades: {}, // id -> count owned
  seenEras: {}, // eraKey -> true (has been unlocked at least once)
  soundEnabled: true,
  totalBerriesEarned: 0,
  highestBerries: 0,
  unlockedAchievements: {}, // id -> unlockedAt timestamp
  discordShown: false, // one-time flag: Discord invite modal has been shown
  lastSavedAt: Date.now(),
  createdAt: Date.now(),
  version: 1,
});

export const loadState = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultState();
    const parsed = JSON.parse(raw);
    return { ...defaultState(), ...parsed };
  } catch {
    return defaultState();
  }
};

export const saveState = (state) => {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...state, lastSavedAt: Date.now() }),
    );
  } catch {
    // ignore quota errors
  }
};

export const clearState = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // noop
  }
};
